import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Productos from "@/pages/Productos";
import ProductoDetail from "@/pages/ProductoDetail";
import LoteDetail from "@/pages/LoteDetail";
import Movimientos from "@/pages/Movimientos";
import Kardex from "@/pages/Kardex";
import InventarioAnalisis from "@/pages/InventarioAnalisis";
import Integridad from "@/pages/Integridad";
import Alertas from "@/pages/Alertas";
import Ranking from "@/pages/Ranking";
import ReporteMensual from "@/pages/ReporteMensual";
import Notificaciones from "@/pages/Notificaciones";
import Proveedores from "@/pages/Proveedores";
import CuentasPorPagar from "@/pages/CuentasPorPagar";

function App() {
  return (
    <div className="App">
      <Toaster richColors position="top-right" />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/productos" element={<Productos />} />
              <Route path="/productos/:id" element={<ProductoDetail />} />
              <Route path="/lotes/:id" element={<LoteDetail />} />
              <Route path="/movimientos" element={<Movimientos />} />
              <Route path="/kardex" element={<Kardex />} />
              <Route path="/inventario" element={<InventarioAnalisis />} />
              <Route path="/integridad" element={<Integridad />} />
              <Route path="/proveedores" element={<Proveedores />} />
              <Route path="/cuentas-por-pagar" element={<CuentasPorPagar />} />
              <Route path="/alertas" element={<Alertas />} />
              <Route path="/ranking" element={<Ranking />} />
              <Route path="/reporte" element={<ReporteMensual />} />
              <Route path="/notificaciones" element={<Notificaciones />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
